import {
  CmpButton,
  CmpDatePicker,
  CmpDatePickerField001,
  CmpSelectBox,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./FactTransaction.css";
import {
  GetAttributes,
  GetSummary,
  GetSummary001,
  GetUpdate,
} from "./FactTransactionAction";
import moment from "moment";
import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";
import dayjs from "dayjs";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import { Lutfi_Sync_Summary_GETROW } from "../../Server/ApiV2";

export default function FactTransaction() {
  const InputFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const isMobAndTab = useMediaQuery("(max-width:900px)");
  const vRdxuserInfo = useSelector((state) => state.login.value);
  // eslint-disable-next-line no-unused-vars
  const [sLoadObj, setLoadObj] = useState({
    code: "",
    dateFrom: dayjs().startOf("month").toDate(),
    dateTo: dayjs().toDate(),
  });
  const [sTransactionList, setTransactionList] = useState([
    // {
    //   "UId": "INV02",
    //   "Name1": "Purchase Order"
    // },
    // {
    //   "UId": "WMINV04",
    //   "Name1": "Purchase Return"
    // },
    // {
    //   "UId": "WMINV08",
    //   "Name1": "Sales Invoice"
    // },
    // {
    //   "UId": "WMINV10",
    //   "Name1": "Stock Transfer"
    // }
  ]);
  const [sGridrows, setGridrows] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });

  const fOnChangeInput = (e) => {
    console.log({ [e.target.name]: e.target.value });
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));

    GetSummaryList(e.target.value);
  };

  const fFactSync = async (e) => {
    let filteredArray = sGridrows
      .filter((item) => item.L_Chk === "Y")
      .map(({ PUR_FYCODE, PUR_DOCTYPE, PUR_DOCNO }) => ({
        PUR_FYCODE,
        PUR_DOCTYPE,
        PUR_DOCNO,
      }));

    let checkPartyAndGravityCount = sGridrows.find(
      (item) =>
        (item.GravityItemCount == 0 ||
          item.GravityItemCount == "" ||
          item.GravityItemCount == null ||
          item.GravityItemCount == undefined ||
          item.Party == "" ||
          item.Party == null ||
          item.Party == undefined) &&
        item.L_Chk === "Y"
    );

    if (!!checkPartyAndGravityCount) {
      if (
        checkPartyAndGravityCount.GravityItemCount == 0 ||
        checkPartyAndGravityCount.GravityItemCount == "" ||
        checkPartyAndGravityCount.GravityItemCount == null ||
        checkPartyAndGravityCount.GravityItemCount == undefined
      ) {
        fAlertToast(
          "FAILED",
          `Gravity Item Count should not be zero  (Document number ${checkPartyAndGravityCount.PUR_DOCNO})`
        );
      }
      if (
        checkPartyAndGravityCount.Party == "" ||
        checkPartyAndGravityCount.Party == null ||
        checkPartyAndGravityCount.Party == undefined
      ) {
        fAlertToast(
          "FAILED",
          `Party should not be empty (Document number ${checkPartyAndGravityCount.PUR_DOCNO})`
        );
      }
    } else {
      let iUpdate = await GetUpdate(sLoadObj?.code, filteredArray);
      if (iUpdate) {
        await GetSummaryList(sLoadObj?.code);
      }
    }
  };

  const fLoad = async (e) => {
    GetSummaryList(sLoadObj?.code);
  };
  const handleSelectionChange = (params) => {
    let modifiedSelect = sGridrows.map((el) => {
      if (params.includes(el.id)) {
        return { ...el, L_Chk: "Y" };
      } else {
        return { ...el, L_Chk: "N" };
      }
    });
    console.log("modifiedSelect", modifiedSelect);
    setGridrows(modifiedSelect);
  };

  //API BIN_ENQUIRY_GETROW
  const GetSummaryList = async (xcode) => {
    let vObj = {
      v_TrnTyp: xcode,
      v_Fromdate: moment(sLoadObj?.dateFrom).format("MM/DD/YYYY"),
      v_Todate: moment(sLoadObj?.dateTo).format("MM/DD/YYYY"),
    };
    const res = await Lutfi_Sync_Summary_GETROW(vObj);
    console.log("vSummaryList", res);
    if (res.status === 200) {
      setGridrows(res?.data?.ResultSet);
    } else {
      setGridrows([]);
    }
  };

  const [sSummaryGridColumn2, setSummaryGridColumn2] = useState([
    { field: "PUR_FYCODE", headerName: "PUR_FYCODE", width: 50, hide: true },
    { field: "PUR_DOCTYPE", headerName: "PUR_DOCTYPE", width: 100, hide: true },
    {
      field: "PUR_DOCNO",
      headerName: "Doc No",
      width: 80,
      align: "center",
      headerAlign: "center",
    },
    { field: "Party", headerName: "Party", width: 100, hide: true },
    {
      field: "PostDt",
      headerName: "Date",
      width: 100,
      align: "center",
      headerAlign: "center",
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    { field: "Party", headerName: "Party Code", width: 100, hide: true },
    {
      field: "PartyName",
      headerName: "Party Name",
      flex: isMobAndTab ? 0 : 1,
      width: isMobAndTab && 450,
      align: "left",
      headerAlign: "center",
    },
    {
      field: "Loc",
      headerName: "Loc Code",
      width: 90,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "LocName",
      headerName: "Location Name",
      width: 240,
      headerAlign: "center",
    },
    {
      field: "GravityItemCount",
      headerName: "Item Count",
      width: 100,
      align: "center",
      headerAlign: "center",
    },
    { field: "TrnTyp", headerName: "TrnTyp", width: 150, hide: true },
  ]);

  useEffect(() => {
    // GetGitterColumns(
    //   setSummaryGridColumn2,
    //   "FactTrans_SUMMARY",
    //   sSummaryGridColumn2
    // );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    InputFocusOnLoad.current?.focus();
  }, []);
  const onLoad = async () => {
    let iAttributeResp = await GetAttributes(setTransactionList);
    let vTrnType = iAttributeResp?.TransType;
    if (vTrnType.length > 0) {
      setLoadObj((obj) => ({
        ...obj,
        code: vTrnType[0].UId,
      }));
      GetSummaryList(vTrnType[0].UId);
    }
  };
  useEffect(() => {
    onLoad();
  }, []);
  return (
    <div className="fact-sync">
      <Grid container spacing={1} sx={{ alignItems: "center", mt: 3 }}>
        <Grid item lg={2} md={3} xs={6} sm={2.5}>
          <CmpDatePicker
            xLabelText={"FromDate"}
            xValue={sLoadObj?.dateFrom}
            xOnChange={(newValue) => {
              setLoadObj((prev) => ({ ...prev, dateFrom: newValue?.$d }));
            }}
            xName={"dateFrom"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item lg={2} md={3} xs={6} sm={2.5}>
          <CmpDatePicker
            xLabelText={"ToDate"}
            xValue={sLoadObj?.dateTo}
            xOnChange={(newValue) => {
              setLoadObj((prev) => ({ ...prev, dateTo: newValue?.$d }));
            }}
            xName={"dateFrom"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>

        <Grid item lg={3} md={3} xs={12} sm={3}>
          <CmpSelectBox
            xLabelText="TrnType"
            xValue={
              sLoadObj.code === "" ? sTransactionList[0]?.UId : sLoadObj.code
            }
            xOnChange={(event) => fOnChangeInput(event)}
            xName={"code"}
            xData={sTransactionList}
            xValueMember={""}
            xDispalyMember={""}
            xError={false}
            xErrorMessage={false}
            xDisable={false}
            xsize={"small"}
          />
          {/* <CmpTextFieldEnter
              xref={InputFocusOnLoad}
              xLabelText={"Documen No"}
              xVariant={"outlined"}
              xValue={sLoadObj.code}
              xOnChange={(event) => fOnChangeInput(event)}
              xReadOnly={false}
              xType={"text"}
              xName={"code"}
              xOnKeyUp={(e) => {
                fOnKeyUp(e);
              }}
              xOnEnter={(e) => {
                fOnKeyUp(sEnterKeyObj);
              }}
              xSmShow={!!vMediaQuery}
              xError={sError != ""}
              xErrorMessage={sError}
            /> */}
        </Grid>
        <Grid item md={"auto"} xs={6} sm={2}>
          <CmpButton
            xbtnName="Load"
            xOnClick={fLoad}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
            xId={"IdClear"}
          />
        </Grid>
        <Grid item md={"auto"} xs={6} sm={2}>
          <CmpButton
            xbtnName="FactSync"
            xOnClick={fFactSync}
            xVariant="contained"
            xDisabled={sGridrows?.length == 0}
            xSize="small"
          />
        </Grid>
      </Grid>
      <Box
        sx={{ height: { xs: "73vh", sm: "80vh" }, width: "100%", mt: 2 }}
        // className="bin-transfer-data"
      >
        <DataGridPro
          rowHeight={30}
          headerHeight={40}
          rows={sGridrows}
          columns={sSummaryGridColumn2}
          hideFooter={sGridrows?.length < 100}
          components={
            !vMediaQuery && {
              Toolbar: GridToolbar,
            }
          }
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
          }}
          checkboxSelection
          onSelectionModelChange={handleSelectionChange}
          selectionModel={sGridrows
            ?.filter((row) => row?.L_Chk === "Y")
            .map((row) => row?.id)}
          getRowId={(row) => row?.id}
        />
      </Box>
    </div>
  );
}
